import { make } from 'vuex-pathify';
import { NewsService } from '@/services/news';
import { errorCatch } from '../utils';

const newsService = new NewsService();

export const state = {
  newsList: [],
  newsInstance: {},
  lastRemovedNews: {},
  lastEditedNews: {},
  loading: false,
  error: {}
};

export const mutations = {
  REMOVE_NEWS(state: any, payload: any) {
    const index = state.newsList.indexOf(payload);
    state.newsList.splice(index, 1);
  },
  ADD_NEWS(state: any, payload: any) {
    state.newsList.push(payload);
  },
  UPDATE_NEWS(state: any, payload: any) {
    const lastEditedNews = state.newsList.find(
      (news: { id: string }) => news.id === payload
    );
    const objIndex = state.newsList.findIndex(
      (obj: any) => obj.id === payload.id
    );
    state.newsList[objIndex] = lastEditedNews;
  },
  ...make.mutations(state),
  SET_ERROR(state: any, error: any) {
    errorCatch(state, error);
  },
  CLEAR_ERROR(state: any) {
    state.error = {};
  }
};

export const actions = {
  clearError: ({ commit }: any) => commit('CLEAR_ERROR'),
  createNews: async ({ dispatch, commit }: any, payload: any) => {
    dispatch('clearError');
    commit('SET_LOADING', true);
    await new Promise((resolve, reject) => {
      newsService
        .createNews(payload)
        .then(res => {
          commit('NEWS_ADD', res);
          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          // error place holder commit('error/SET_ERROR', err, {root: true})
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },
  fetchNews: async ({ commit, dispatch }: any) => {
    dispatch('clearError');
    commit('SET_LOADING', true);
    await new Promise((resolve, reject) => {
      newsService
        .fetchNews()
        .then(res => {
          commit('SET_NEWS_LIST', res);
          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          // error place holder commit('error/SET_ERROR', err, {root: true})
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },
  getNewsArticle: async ({ commit, dispatch }: any, payload: any) => {
    dispatch('clearError');
    commit('SET_LOADING', true);
    await new Promise((resolve, reject) => {
      newsService
        .getNewsArticle(payload.id)
        .then(res => {
          console.log(res);

          commit('SET_NEWS_INSTANCE', res);

          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          // error place holder commit('error/SET_ERROR', err, {root: true})
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },
  updateNews: async ({ commit, dispatch }: any, payload: any) => {
    dispatch('clearError');
    commit('SET_LOADING', true);
    await new Promise((resolve, reject) => {
      newsService
        .updateNews(payload.id, payload)
        .then(res => {
          commit('NEWS_UPDATE', res);
          resolve();
          // dispatch(
          //   'snackbar/createSnack',
          //   {
          //     color: 'primary',
          //     type: 'edit',
          //     href: false,
          //     msg: `Edited: ${res.title}`,
          //     text: 'Close',
          //     to: false,
          //     timeout: 6000,
          //     action: () => {}
          //   },
          //   { root: true }
          // );
        })
        .catch(err => {
          console.log(err);
          commit('SET_ERROR', err);

          // dispatch(
          //   'snackbar/createSnack',
          //   {
          //     color: 'secondary',
          //     type: 'error',
          //     href: false,
          //     msg: `Error cant update news`,
          //     text: 'Close',
          //     to: false,
          //     timeout: 6000,
          //     action: function() {}
          //   },
          //   { root: true }
          // );
          // error place holder commit('error/SET_ERROR', err, {root: true})
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },
  deleteNews: async ({ commit, dispatch }: any, payload: number) => {
    dispatch('clearError');
    commit('SET_LOADING', true);
    await new Promise((resolve, reject) => {
      newsService
        .deleteNews(payload)
        .then(res => {
          commit('NEWS_REMOVE', res);
          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          // error place holder commit('error/SET_ERROR', err, {root: true})
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  }
};

export const getters = {
  getLoading: (state: any) => state.loading,
  isVerified: (state: any) => state.verified,
  getNewsList: (state: any) => state.newsList,
  getNewsInstance: (state: any) => state.newsInstance
};
